const getters = {
  table: (state) => state.table
};

export default {
  getters
};
